module.exports = __webpack_public_path__ + "img/01.1936f22e.jpg";